import { getDefaultConfig } from './business';
export default {
    dialog: getDefaultConfig(),
};
